import Box from "@mui/material/Box";
import { styled, Theme } from "@mui/material/styles";
import { customScrollBar } from "../../themes/mixins";

export const WrapperBox = styled(Box)({
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
}) as typeof Box;

export const ErrorMessageBox = styled(Box)(({ theme }: { theme: Theme }) => ({
    display: "block",
    fontSize: theme.typography.fontSize, // 14px
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: theme.palette.warning.main, // clay (orange/brown)
    margin: `${theme.spacing(2)} 0 0`, // 1em = 16px
    padding: theme.spacing(2), // 1em = 16px
    overflow: "auto",
    ...customScrollBar,
})) as typeof Box;
